<template>
  <div class="fwd-orange">
    <form>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <input
          class="input fwd-dark-green"
          :id="id"
          @input="(event) => onInput(event)"
          :placeholder="placeholder"
          :maxlength="maxLength"
          :value="value"
          :disabled="disabled"
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  setup() {},
  props: {
    id: String,
    placeholder: String,
    maxLength: Number,
    value: String,
    disabled: Boolean,
  },
  methods: {
    onInput(event) {
      let value = event.target.value;
      this.$emit("updateModel", value);
    },
    saveSettings() {
      this.$emit("submit");
    },
  },
};
</script>

<style></style>
